/* import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";
const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
}; */
export const materialOrderViewOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: false,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  viewBtn: false,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    // account账号、realName姓名、money总金额
    {
      label: "账号",
      prop: "account",
      // search: true,
    },
    {
      label: "姓名",
      prop: "realName",
      // search: true,
    },
    {
      label: "前仓名称",
      prop: "warehouseName",
      // search:true,
    },
    {
      label: "客户地址",
      prop: "customAddress",
    },
    {
      label: "提货产品",
      prop: "goodsName",
    },
    {
      label: "单价",
      prop: "price",
      // search:true,
    },
    {
      label: "数量",
      prop: "num",
      // search:true,
    },
    {
      label: "提货时间",
      prop: "firstPickUpTime",
      type: "datetime",
      search: false,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },

    /* {
      label: "结束时间",
      prop: "endTime",
      type: "datetime",
      search: true,
      hide: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    }, */
  ],
};
